var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_49",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m61.106,34.4l-7.837-5.582c-.263-.188-.42-.491-.42-.815v-12.462c0-1.175-.953-2.128-2.128-2.128h-2.439c-1.175,0-2.128.953-2.128,2.128v12.495c0,.305-.139.593-.378.783l-7.011,5.574c-.758.603-1.178,1.534-1.129,2.501l1.9,49.179c.049.963.86,1.919,1.803,2.124h0c4.764,1.038,12.559,1.038,17.323,0l.232-.05c.815-.177,1.516-1.004,1.559-1.837l1.907-49.314c.052-1.023-.421-2.002-1.256-2.597Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }